import { Order } from 'models/order';
import { createContext } from 'react';
import { ApolloQueryResult, OperationVariables } from '@apollo/client';

// The live order, read from the Apollo cache (DD-3231). There is no setter: a change reaches
// the cache from the mutation result, an ORDER_CHANGED event or useRefreshOrder.
type OrderDetailsContextType = {
    order: Order;
    refetch: (variables?: Partial<OperationVariables>) => Promise<ApolloQueryResult<any>>;
};

export const OrderDetailsContext = createContext<OrderDetailsContextType>({
    order: {} as Order,
    refetch: async () => {
        return {} as ApolloQueryResult<any>;
    },
});
